// frontend/src/utils/rouletteUi.js

export const SIGN_EMOJI = {
  aries: '♈',
  tauro: '♉',
  geminis: '♊',
  cancer: '♋',
  leo: '♌',
  virgo: '♍',
  libra: '♎',
  escorpio: '♏',
  sagitario: '♐',
  capricornio: '♑',
  acuario: '♒',
  piscis: '♓'
};

export function genderEmoji(g) {
  if (!g) return '';
  const key = String(g).toLowerCase();

  if (key === 'hombre') return '♂';
  if (key === 'mujer') return '♀';

  return '⚧';
}

export function toAbsolutePhoto(p, apiOrigin) {
  if (!p) return '/default-profile.png';
  if (/^https?:\/\//i.test(p)) return p;

  let clean = String(p)
    .replace(/^https?:\/\/[^/]+/i, '')
    .replace(/^\//, '')
    .replace(/^uploads\//, '');

  if (!clean.startsWith('profile_photos/')) {
    clean = `profile_photos/${clean}`;
  }

  return `${String(apiOrigin || '').replace(/\/+$/, '')}/${encodeURI(clean)}`;
}